import React from 'react'
import { Dropdown } from 'components/AutoCompleteDropdown'
import { US_STATES } from './utils'

interface Props {
  value?: string
  onChange: (id: string) => void
  hasBottomContent?: boolean
  errorMessage?: string | undefined
  onBlur?:
    | ((touched: React.FocusEvent<HTMLDivElement> | React.KeyboardEvent<HTMLElement>) => void)
    | undefined
}

export const StatesDropdown: React.VFC<Props> = ({
  value,
  onChange,
  hasBottomContent,
  errorMessage,
  onBlur,
}) => (
  <Dropdown
    label="States"
    value={value}
    options={US_STATES}
    onSelectChange={(_: React.SyntheticEvent<HTMLElement>, data: { value: string }) => {
      onChange(data.value)
    }}
    selectOnNavigation={false}
    hasBottomContent={hasBottomContent}
    errorMessage={errorMessage}
    onBlur={onBlur}
  />
)
